var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-pet",class:{ 'btn-pet-active': _vm.allSelected },on:{"click":_vm.onPetsSelected}},[_c('div',{staticClass:"btn-pet-name"},[_vm._v("All")]),_c('div',{staticClass:"btn-pet-breed"},[_vm._v(_vm._s(_vm.petNames))])])
}
var staticRenderFns = []

export { render, staticRenderFns }